import React, { useRef } from "react";
import "./PrintableTable.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLoader } from "./Loder/Loder";
import { Tooltip } from "@mui/material";
import imageFile from "../../assets/images/logo.png";

// const PrintableTable = (columns, data, name) => {
//   let htmls;
//   let column;
//   // if(rows.length>0)
//   // {
//   htmls = data?.map((item, index) => {
//     return ` <tr key={index} style={{ border: "1px solid black" }}>
//        ${columns
//          ?.filter((ele) => ele.name !== "action")
//         ?.map((column) => `<td>${item[column.name]}</td>`)}
//       </tr>`;
//   });

//   //}
//   column = columns
//     ?.filter((ele) => ele.name !== "action")
//    ?.map((column) => {
//       return `<th>${column.title}</th>`;
//     });
//   console.log(column.join(""), htmls.join("").split(",").join(""));

//   // if (printableContent) {
//   const printWindow = window.open("", "", "width=2000,height=1400");
//   printWindow.document.open();
//   printWindow.document.write(`
//       <html>
//       <head>
//       <title>${name}</title>
//      <style>

// table {
// width: 100%;
// border-collapse: collapse;
// border-spacing: 0;
// font-size: 14px;
// }
// th {
// background-color: #343a40;
// color: #fff;
// text-align: left;
// padding: 10px;
// }
// tr:nth-child(even) {
// background-color: #f2f2f2;
// }

// tr:hover {
// background-color: #d4d4d4;
// }
// td {
// border: 1px solid #ccc;
// }
//      </style>

//     </head>
//         <body>
//         <table class="custom-table">
//         <thead>
//         <tr>
//         ${column.join("")}
//         </tr>
//         </thead>
//         <tbody>
//         ${htmls.join("").split(",").join("")}
//         </tbody>
//         </table>
//         </body>
//       </html>
//     `);
//   printWindow.document.close();
//   printWindow.print();
//   printWindow.close();
//   //}
// };

// const ExportPDF = ({ columns, data, name, buttonName }) => {
//   const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

//   // const tableRef = useRef(null);

//   // const handleDownload = () => {
//   //   const doc = new jsPDF();
//   //   const table = tableRef.current;

//   //   html2canvas(table).then((canvas) => {
//   //     const imgData = canvas.toDataURL("image/png");
//   //     const imgWidth = 190; // Width of the PDF
//   //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//   //     doc.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
//   //     doc.save(`${name}.pdf`);
//   //   });
//   // };

//   const handleDownload = () => {
//     openLoader();
//     // Create table
//     const table = document.createElement("table");
//     table.setAttribute("border", "1");
//     // table.style.visibility = "hidden";
//     // table.style.position = "absolute";

//     // Create table header
//     const thead = document.createElement("thead");
//     const headerRow = document.createElement("tr");
//     columns
//       ?.map((ele) =>
//         ele.title !== "Action" ? { ...ele, tile: "Action", name: "" } : ele
//       )
//       .forEach((col) => {
//         const th = document.createElement("th");
//         th.textContent = col.title;
//         headerRow.appendChild(th);
//       });
//     thead.appendChild(headerRow);
//     table.appendChild(thead);

//     // Create table body
//     const tbody = document.createElement("tbody");
//     data?.forEach((row) => {
//       const tr = document.createElement("tr");
//       columns.forEach((col) => {
//         const td = document.createElement("td");
//         td.textContent = row[col.name] === null ? "-" : row[col.name];
//         tr.appendChild(td);
//       });
//       tbody.appendChild(tr);
//     });
//     table.appendChild(tbody);

//     // Append the table to the document body temporarily
//     document.body.appendChild(table);

//     // Wait for the table to be rendered before capturing it
//     setTimeout(() => {
//       html2canvas(table)
//         .then((canvas) => {
//           const imgData = canvas.toDataURL("image/png");
//           const imgWidth = 190; // Width of the PDF
//           const imgHeight = (canvas.height * imgWidth) / canvas.width;
//           const doc = new jsPDF();
//           doc.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
//           doc.save(`${name}.pdf`);
//           document.body.removeChild(table); // Remove the table from the document body
//           closeLoader();
//         })
//         .catch((error) => {
//           console.error("Error capturing table:", error);
//           document.body.removeChild(table); // Ensure table is removed even if an error occurs
//         });
//     }, 1000); // Adjust delay as necessary for your use case
//   };
//   return (
//     // <div>
//     <Tooltip title="Export as PDF">
//       <button type="button" className="Excel" onClick={handleDownload}>
//         {/* {buttonName} */}
//         <i className="fa fa-file-pdf"></i>
//       </button>
//     </Tooltip>
//     // </div>
//   );
// };

const ExportPDF = ({ columns, data, name, buttonName, auctionType }) => {
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

  const handleDownload = (logo) => {
    openLoader();

    // Determine the page size based on the number of columns
    let pageSize = "a1";
    let orientation = "landscape";
    let pageWidth = 841; // A4 landscape page width in mm
    let pageHeight = 594; // A4 landscape page height in mm
    let fontSize = 10; // Base font size
    let cellPadding = 1; // Cell padding in mm
    let headerHeight = 8; // Height of header row
    let cellHeight = 8; // Default height of each row

    const margin = 10; // Margin in mm
    const minCellWidth = 20; // Minimum width for each column to be readable

    const numColumns = columns.length;
    const numColumnsPerPage = Math.floor(
      (pageWidth - 2 * margin) / minCellWidth
    );

    // Adjust page size, font size, and cell size based on the number of columns
    if (numColumns > numColumnsPerPage) {
      if (numColumns > numColumnsPerPage * 2) {
        pageSize = "a1";
        pageWidth = 841; // A1 landscape page width in mm
        pageHeight = 594; // A1 landscape page height in mm
        fontSize = 8; // Smaller font size for more content
        cellPadding = 1; // Reduce padding
        headerHeight = 8; // Smaller header height
        cellHeight = 8; // Smaller cell height
      } else {
        pageSize = "a2";
        pageWidth = 594; // A2 landscape page width in mm
        pageHeight = 420; // A2 landscape page height in mm
        fontSize = 9; // Slightly smaller font size
        cellPadding = 1.5; // Adjust padding
        headerHeight = 9; // Adjust header height
        cellHeight = 9; // Adjust cell height
      }
    }

    const doc = new jsPDF(orientation, "mm", pageSize); // Create jsPDF document with dynamic size

    // Add the logo at the top center of the page
    const logoWidth = 40; // Set the desired logo width
    const logoHeight = 40; // Set the desired logo height
    const logoX = (doc.internal.pageSize.getWidth() - logoWidth) / 2; // Center the logo
    const logoY = 10; // Y position of the logo

    // Add the logo image (adjust the format if necessary)
    doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    // Add the title below the logo
    const titleY = logoY + logoHeight + 5; // Position the title below the logo
    doc.setFontSize(12); // Set font size for the title
    doc.text(
      auctionType + " AUCTION",
      doc.internal.pageSize.getWidth() / 2,
      titleY,
      {
        align: "center",
      }
    ); // Center the title

    // Calculate the Y position for starting the table, accounting for margin
    const startY = titleY + 20;

    // Set dynamic font size
    doc.setFontSize(fontSize);

    let yPosition = margin; // Initial y position for content

    // Calculate the number of columns that can fit on one page
    const columnsPerPage = Math.floor((pageWidth - 2 * margin) / minCellWidth);

    // Divide columns into chunks that fit within a single page
    const columnChunks = [];
    for (let i = 0; i < columns.length; i += columnsPerPage) {
      columnChunks.push(columns.slice(i, i + columnsPerPage));
    }

    // Iterate over each chunk of columns
    columnChunks.forEach((columnChunk, chunkIndex) => {
      // Reset y position for each new chunk
      yPosition = margin + (chunkIndex > 0 ? headerHeight : 0) + 50;

      // Render the header for the current chunk
      columnChunk.forEach((col, index) => {
        if (col.title !== "Action") {
          const cellWidth = (pageWidth - 2 * margin) / columnChunk.length; // Adjust cell width based on chunk
          doc.setFillColor(52, 58, 64); // Dark gray background for header
          doc.rect(
            margin + index * cellWidth,
            yPosition,
            cellWidth,
            headerHeight,
            "F"
          ); // 'F' for filled
          doc.setTextColor(255, 255, 255); // White text
          doc.text(
            String(col.title),
            margin + index * cellWidth + cellPadding,
            yPosition + headerHeight / 1.5
          );
        }
      });

      yPosition += headerHeight; // Move y position down for table body

      // Reset text color for body
      doc.setTextColor(0, 0, 0); // Black text

      // Render the table body for the current chunk of columns
      data.forEach((row, rowIndex) => {
        let rowHeight = cellHeight; // Default row height

        columnChunk.forEach((col, colIndex) => {
          if (col.title !== "Action") {
            const cellWidth = (pageWidth - 2 * margin) / columnChunk.length; // Adjust cell width based on chunk
            const cellText = row[col.name] === null ? "-" : row[col.name];
            const textHeight = doc.getTextDimensions(String(cellText)).h; // Get text height, convert to string
            rowHeight = Math.max(rowHeight, textHeight + 2 * cellPadding); // Adjust row height if needed

            // Check if we need to add a new page
            if (yPosition + rowHeight > pageHeight - margin) {
              doc.addPage();
              yPosition = margin + headerHeight; // Reset y position and account for the header height

              // Re-render the header on new page for the current chunk
              columnChunk.forEach((col, index) => {
                if (col.title !== "Action") {
                  doc.setFillColor(52, 58, 64); // Dark gray background
                  doc.rect(
                    margin + index * cellWidth,
                    yPosition,
                    cellWidth,
                    headerHeight,
                    "F"
                  ); // 'F' for filled
                  doc.setTextColor(255, 255, 255); // White text
                  doc.text(
                    String(col.title),
                    margin + index * cellWidth + cellPadding,
                    yPosition + headerHeight / 1.5
                  );
                }
              });

              yPosition += headerHeight; // Move down after header
              doc.setTextColor(0, 0, 0); // Reset text color for body
            }

            // Alternate row color
            if (rowIndex % 2 === 0) {
              doc.setFillColor(242, 242, 242); // Light gray background for even rows
              doc.rect(
                margin + colIndex * cellWidth,
                yPosition,
                cellWidth,
                rowHeight,
                "F"
              ); // 'F' for filled
            }

            // Draw cell borders
            doc.setDrawColor(204, 204, 204); // Light gray border
            doc.rect(
              margin + colIndex * cellWidth,
              yPosition,
              cellWidth,
              rowHeight
            );

            // Add cell text
            doc.text(
              String(cellText),
              margin + colIndex * cellWidth + cellPadding,
              yPosition + rowHeight / 2
            );
          }
        });

        yPosition += rowHeight; // Move y position down for the next row
      });

      if (chunkIndex < columnChunks.length - 1) {
        doc.addPage(); // Add a new page for the next chunk if there are more chunks
      }
    });

    doc.save(`${name}.pdf`);
    closeLoader();
  };

  function convertImageUrlToBase64() {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Handle CORS issues if the image is from a different origin

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const dataURL = canvas.toDataURL("image/png"); // Get Base64 string from the canvas
        resolve(dataURL);
        handleDownload(dataURL);
      };

      img.onerror = (error) => {
        reject("Failed to load image.");
      };

      img.src = imageFile;
    });
  }
  return (
    <Tooltip title="Export as PDF">
      <button type="button" className="Excel" onClick={convertImageUrlToBase64}>
        <i className="fa fa-file-pdf"></i>
      </button>
    </Tooltip>
  );
};

// const ExportHTMl = ({ columns, data, name }) => {
//   const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

//   const handleDownload = () => {
//     openLoader();

//     // Create div and set class
//     const tableBox = document.createElement("div");
//     tableBox.className = "TableBox"; // Set the class

//     // Create table
//     const table = document.createElement("table");
//     table.setAttribute("border", "1");

//     // Create table header
//     const thead = document.createElement("thead");
//     const headerRow = document.createElement("tr");
//     columns
//       ?.filter((ele) => ele.title !== "Action")
//       ?.forEach((col) => {
//         const th = document.createElement("th");
//         th.textContent = col.title;
//         headerRow.appendChild(th);
//       });
//     thead.appendChild(headerRow);
//     table.appendChild(thead);

//     // Create table body
//     const tbody = document.createElement("tbody");
//     data?.forEach((row) => {
//       const tr = document.createElement("tr");
//       columns.forEach((col) => {
//         const td = document.createElement("td");
//         td.textContent = row[col.name] === null ? "-" : row[col.name];
//         tr.appendChild(td);
//       });
//       tbody.appendChild(tr);
//     });
//     table.appendChild(tbody);

//     // Append the table to the div
//     tableBox.appendChild(table);

//     // Create a blob from the tableBox inner HTML
//     const blob = new Blob([tableBox.innerHTML], { type: "text/html" });
//     const url = URL.createObjectURL(blob);

//     // Create a link element and trigger download
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${name}.html`;
//     document.body.appendChild(a);
//     a.click();

//     // Clean up
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//     closeLoader();
//   };
//   return (
//     <div>
//       <Tooltip title="Export as HTML">
//         <button type="button" className="Excel" onClick={handleDownload}>
//           {" "}
//           <i className="fa fa-file-code"></i>
//         </button>
//       </Tooltip>
//     </div>
//   );
// };

const ExportHTMl = ({ columns, data, name }) => {
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

  const handleDownload = () => {
    openLoader();

    // Create div and set class
    const tableBox = document.createElement("div");
    tableBox.className = "TableBox"; // Set the class

    // Create table
    const table = document.createElement("table");
    table.setAttribute("border", "1");

    // Create table header
    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");
    columns
      ?.filter((ele) => ele.title !== "Action")
      ?.forEach((col) => {
        const th = document.createElement("th");
        th.textContent = col.title;
        headerRow.appendChild(th);
      });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    // Create table body
    const tbody = document.createElement("tbody");
    data?.forEach((row) => {
      const tr = document.createElement("tr");
      columns.forEach((col) => {
        const td = document.createElement("td");
        td.textContent = row[col.name] === null ? "-" : row[col.name];
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);

    // Append the table to the div
    tableBox.appendChild(table);

    // Create a style element for CSS
    const style = document.createElement("style");
    style.textContent = `
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        font-size: 14px;
      }
      th {
        background-color: #343a40;
        color: #fff;
        text-align: left;
        padding: 10px;
      }
      tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      tr:hover {
        background-color: #d4d4d4;
      }
      td {
        border: 1px solid #ccc;
        padding: 8px; /* Adjust cell padding */
      }
    `;

    // Append the style to the table box
    tableBox.appendChild(style);

    // Create a blob from the tableBox inner HTML
    const blob = new Blob([tableBox.innerHTML], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    // Create a link element and trigger download
    const a = document.createElement("a");
    a.href = url;
    a.download = `${name}.html`;
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    closeLoader();
  };

  return (
    <div>
      <Tooltip title="Export as HTML">
        <button type="button" className="Excel" onClick={handleDownload}>
          {" "}
          <i className="fa fa-file-code"></i>
        </button>
      </Tooltip>
    </div>
  );
};

const ExportToPDF = ({ data, dataNew, fileName, auctionType }) => {
  const columnsData =
    fileName !== "AuctionSession"
      ? [
          { name: "teaTypeName", title: "Tea Type" },
          { name: "saleDate", title: "Sale Date" },
          { name: "buyersPromptDate", title: "Buyers Prompt Date" },
          { name: "sellersPromptDate", title: "Sellers Prompt Date" },
          { name: "status", title: "Status" },
        ]
      : [
          { name: "auctioner", title: "Auctioneer" },
          { name: "teaTypeName", title: "Tea type" },
          { name: "category", title: "Category" },
          { name: "SessionType", title: "Session Type" },
          { name: "saleDate", title: "Sale Date" },
          { name: "startDate", title: "Start Date" },
          { name: "enddate", title: "End Date" },
          { name: "minimumBidTime", title: "Minimum Bid" },
          { name: "noOfLots", title: "Lots" },
          { name: "status", title: "Status" },
        ];

  const columnsDataNew =
    fileName !== "AuctionSession"
      ? [
          { name: "season", title: "Season" },
          { name: "saleNo", title: "Sale No" },
          { name: "catalogClosingDate", title: "Catalog Closing Date" },
          { name: "catalogPublishingDate", title: "Catalog Publishing Date" },
          { name: "noOfAuctionDays", title: "No Of Auction Days" },
          // { name: "averageinPercentage", title: "Average in Percentage" },
          // { name: "priceMovement", title: "priceMovement" },
          // { name: "status", title: "Status" },

          // { name: "pop", title: "pop" },
        ]
      : [
          { name: "season", title: "Season" },
          { name: "saleNo", title: "Sale No" },
          { name: "saleDate", title: "Sale Date" },
          { name: "teaType", title: "Tea Type" },
          { name: "noOfSession", title: "No Of Session" },
          { name: "dealBookClosingDate", title: "Deal Book Closing Date" },
        ];
  const exportToPDF = (logo) => {
    // Initialize jsPDF
    const doc = new jsPDF();

    // Function to add table to PDF
    // const addTableToPDF = (columns, data, margin) => {
    //   // Add the logo at the top center of the page
    //   const logoWidth = 40; // Set the desired logo width
    //   const logoHeight = 30; // Set the desired logo height
    //   const logoX = (doc.internal.pageSize.getWidth() - logoWidth) / 2; // Center the logo
    //   const logoY = 10; // Y position of the logo

    //   // Add the logo image (adjust the format if necessary)
    //   doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    //   // Add the title below the logo
    //   const titleY = logoY + logoHeight + 5; // Position the title below the logo
    //   doc.setFontSize(12); // Set font size for the title
    //   doc.text("title", doc.internal.pageSize.getWidth() / 2, titleY, {
    //     align: "center",
    //   }); // Center the title

    //   // Map columns to titles for the header row
    //   const headers = columns?.map((col) => col.title);
    //   // Map data to rows
    //   const rows = data?.map((row) => columns?.map((col) => row[col.name]));

    //   // Use jsPDF-AutoTable plugin to add the table
    //   // doc.autoTable({
    //   //   head: [headers],
    //   //   body: rows,
    //   //   startY: doc.autoTable.previous?.finalY || 10, // Add table below previous one
    //   //   theme: "grid",
    //   //   headStyles: {
    //   //     fillColor: [24, 62, 41], // Header background color
    //   //     textColor: [255, 255, 255], // Header text color
    //   //     halign: "center", // Text alignment
    //   //   },
    //   //   bodyStyles: {
    //   //     halign: "center", // Text alignment for body cells
    //   //   },
    //   // });
    //   //by sdp
    //   doc.autoTable({
    //     head: [headers],
    //     body: rows,
    //     startY:
    //       margin !== 0
    //         ? doc.autoTable.previous.finalY + 10
    //         : doc.autoTable.previous.finalY,
    //     theme: "grid",
    //     headStyles: {
    //       fillColor: [24, 62, 41],
    //       textColor: [255, 255, 255],
    //       halign: "center",
    //     },
    //     bodyStyles: {
    //       halign: "center",
    //     },
    //     styles: {
    //       cellPadding: 3,
    //       fontSize: 6,
    //       overflow: "linebreak",
    //       cellWidth: "wrap",
    //     },
    //     columnStyles: {
    //       0: { cellWidth: "auto" }, // Adjust the first column width as needed
    //       1: { cellWidth: "auto" },
    //       2: { cellWidth: "auto" },
    //       3: { cellWidth: "auto" },
    //       4: { cellWidth: "auto" },
    //       5: { cellWidth: "auto" },
    //       6: { cellWidth: "auto" },
    //       7: { cellWidth: "auto" },
    //       8: { cellWidth: "auto" },
    //       9: { cellWidth: "auto" },
    //     },
    //   });
    // };
    const addTableToPDF = (columns, data, marginTop, fontSize) => {
      // Add the logo at the top center of the page
      const logoWidth = 25; // Set the desired logo width
      const logoHeight = 25; // Set the desired logo height
      const logoX = (doc.internal.pageSize.getWidth() - logoWidth) / 2; // Center the logo
      const logoY = 10; // Y position of the logo

      // Add the logo image (adjust the format if necessary)
      doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

      // Add the title below the logo
      const titleY = logoY + logoHeight + 5; // Position the title below the logo
      doc.setFontSize(12); // Set font size for the title
      doc.text(
        auctionType + " AUCTION",
        doc.internal.pageSize.getWidth() / 2,
        titleY,
        {
          align: "center",
        }
      ); // Center the title

      // Map columns to titles for the header row
      const headers = columns?.map((col) => col.title);
      // Map data to rows
      const rows = data?.map((row) => columns?.map((col) => row[col.name]));

      // Calculate the Y position for starting the table, accounting for margin
      const startY = titleY + marginTop;

      // Use jsPDF-AutoTable plugin to add the table with the specified top margin
      doc.autoTable({
        head: [headers],
        body: rows,
        startY: startY, // Add margin at the top
        theme: "grid",
        headStyles: {
          fillColor: [24, 62, 41], // Header background color
          textColor: [255, 255, 255], // Header text color
          halign: "center", // Text alignment
        },
        bodyStyles: {
          halign: "center", // Text alignment for body cells
        },
        styles: {
          cellPadding: 1,
          fontSize: fontSize,
          overflow: "linebreak",
          cellWidth: "wrap",
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // Adjust the first column width as needed
          1: { cellWidth: "auto" },
          2: { cellWidth: "auto" },
          3: { cellWidth: "auto" },
          4: { cellWidth: "auto" },
          5: { cellWidth: "auto" },
          6: { cellWidth: "auto" },
          7: { cellWidth: "auto" },
          8: { cellWidth: "auto" },
          9: { cellWidth: "auto" },
        },
      });
    };

    // Add the first table
    addTableToPDF(columnsDataNew, data, 20, 10);
    // debugger;

    // Check if there is a second set of data and columns
    if (
      dataNew &&
      dataNew.length > 0 &&
      columnsData &&
      columnsData.length > 0
    ) {
      // Add space before the second table
      // doc.addPage();
      addTableToPDF(columnsData, dataNew, 50, 9);
    }

    // Save the PDF
    doc.save(`${fileName}.pdf`);
  };

  function convertImageUrlToBase64() {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Handle CORS issues if the image is from a different origin

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const dataURL = canvas.toDataURL("image/png"); // Get Base64 string from the canvas
        resolve(dataURL);
        exportToPDF(dataURL);
      };

      img.onerror = (error) => {
        reject("Failed to load image.");
      };

      img.src = imageFile;
    });
  }

  return (
    <Tooltip title="Export as PDF">
      <button type="button" className="Excel" onClick={convertImageUrlToBase64}>
        <i className="fa fa-file-pdf"></i>
      </button>
    </Tooltip>
  );
};
// export default ExportTable;

export { ExportPDF, ExportHTMl, ExportToPDF };
